<template>
  <div class="container">
    <ReturnBtn
      :path="this.path ? this.path : `konto`"
      blackColor
    ></ReturnBtn>
   <div class="section-title" style="text-align: center; margin-top: 40px;">FILMY PRODUKTU</div>
    <div class="offer-container">
      <section>
        <div class="videos" v-if="videos && videos.length > 0">
          <div v-for="item in videos" :key="item.id">
            <div class="video">
              <img :src="getImage(item)" />
              <div class="video-description">
                <p class="sub-title">{{ item.name }}</p>
                <p>{{ item.description }}</p>
              </div>
              <rounded-color-button
              :label="'Oglądaj'"
              :width="'100%'"
              :classes="'withLetterSpacing'"
              @clicked="moveToVideo(item)"
            />
            </div>

          
          </div>
        </div>
        <div v-else>
          <h1>Brak filmów</h1>
        </div>
      </section>
    </div>

    <div class="flex justify-center text-center" id="videos-select"></div>
  </div>
</template>

<script>
import { SERVER_URL } from "../../axios";
import RoundedColorButton from "../../components/buttons/RoundedColorButton.vue";
import ReturnBtn from "../../components/ReturnBtn.vue";
export default {
  metaInfo: {
    title: "Dagajoga filmy - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "ShopProductVideos",
  data: () => ({}),
  components: { RoundedColorButton , ReturnBtn},
  props: {},

  async mounted() {
    await this.$store.dispatch("shopProducts/fetchShopProductVideos", {
      productId: this.$route.params.id,
    });
    const hasUserAccess = await this.$store.dispatch(
      "shopProducts/checkUserHasAccessToProductVideos",
      { shopProductId: this.$route.params.id }
    );
    if (!hasUserAccess) {
      this.redirectToMainPage();
    }
  },

  computed: {
    videos() {
      return this.$store.getters["shopProducts/getShopProductVideos"];
    },
  },
  methods: {
    redirectToMainPage(signup) {
      this.$router.push({
        name: "Courses",
        params: { name: "", signup: signup },
      });
    },
    moveToVideo(item) {
      this.$router.push({
        name: "ShopProductVideo",
        params: {
          id: item.id,
          shopProductId: this.$route.params.id,
          path: `sklep/filmy/${this.$route.params.id}`,
        },
      });
    },
    getImage(shopProductVideo) {
      const extension = shopProductVideo.imagePath.split(".")[1];
      return `${SERVER_URL}shopProducts/${shopProductVideo.id}.${extension}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  margin: 0;
}

.offer-container {
 
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  h2 {
    font-size: 2.4rem;
    padding-bottom: 1.5rem;
    @media (max-width: 768px) {
      font-size: 2.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1.7rem;
      text-align: center;
      padding-bottom: 1rem;
    }
  }
  p {
    color: #000;
  }
  .path {
    a {
      color: #000;
      text-decoration: none;
      font-weight: 500;
    }
    @media (max-width: 425px) {
      margin-top: -2rem;
      padding-bottom: 20px !important;
    }
  }

  .offer-description {
    p {
      font-size: 1.05rem;
      width: 85%;
      margin-bottom: 3rem;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }

  .box-container {
    display: flex;
    justify-content: center;
    margin-right: 7%;
    margin-bottom: 5rem;

    @media (max-width: 1024px) {
      margin-right: 0%;
    }

    @media (max-width: 425px) {
      flex-wrap: wrap;
    }
    .box {
      @media (max-width: 425px) {
        margin-bottom: 3rem;
      }
    }
  }
}

.videos {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  margin-top: 50px;
  gap:50px;
}
.video {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 4rem;
  flex-wrap: wrap;
  max-width: 400px;
  margin: auto;
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
.video-description p{
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  color: #54514c;
}
.video img {
  width: 300px;
  height: 300px;
  border-radius: 0.5rem;
  object-fit: cover;
  margin: auto;
}

@media (max-width: 700px) {
  .video img {
    max-width: 100%;
    margin-right: 0;
  }
}
</style>
